export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const SUBMIT_TOKEN = 'SUBMIT_TOKEN'
export const CHECK_EMAIL = 'CHECK_EMAIL'
export const NO_EMAIL = 'NO_EMAIL'
